import {UserPermissions} from '../api/generated/enums';

export const debugPermissions = [
  UserPermissions['Enrollments: Delete'],
  UserPermissions['Courses: SkipTimers'],
  UserPermissions['Courses: UnlockCourseContent'],
];
